let store = require("../store");
let actions = require("../actions");

let QuestionEditor = require("../widget/QuestionEditor");

let FormRange = mc.widgets.FormRange;
let FormControls = mc.widgets.FormControls;
let FormFeedback = mc.widgets.FormFeedback;

class ActivityFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activity: mc.utils.clone(this.props.activity),
      errors: [],
      submitting: false
    };
  }

  setDisplayName(evt) {
    this.mutate("displayName", evt.target.value);
  }

  setHours(hours) {
    let { minutes, seconds } = mc.math.duration(this.state.activity.durationSec * 1000);
    this.setDurationSec(hours, minutes, seconds);
  }

  setMinutes(minutes) {
    let { hours, seconds } = mc.math.duration(this.state.activity.durationSec * 1000);
    this.setDurationSec(hours, minutes, seconds);
  }

  setSeconds(seconds) {
    let { hours, minutes } = mc.math.duration(this.state.activity.durationSec * 1000);
    this.setDurationSec(hours, minutes, seconds);
  }

  setDurationSec(h, m, s) {
    let max = 86400;
    let durationSec = Math.max(1, Math.min(max, (h * 3600) + (m * 60) + s));

    this.mutate("durationSec", durationSec);
  }

  setUntimed(evt) {
    this.mutate("durationSec", 0);
  }

  setTimed(evt) {
    this.mutate("durationSec", 30);
  }

  setInstructions(evt) {
    this.mutate("instructions", evt.target.value);
  }

  setQuestions(questions) {
    this.mutate("questions", questions);
  }

  mutate(fieldName, fieldValue) {
    let activity = mc.utils.clone(this.state.activity);
    activity[fieldName] = fieldValue;

    this.setState({ activity });
  }

  saveActivity() {
    let activity = this.state.activity;
    let method = activity.id ? "UPDATE" : "CREATE";

    actions.saveActivity(activity, method).then((function (payload) {
      if (payload.errors.length) {
        this.setState({
          errors: payload.errors,
          submitting: false
        });
      }
      else {
        mc.ui.modal(null);
        rc.actions.loadStudy(payload.activity.studyId);
      }
    }).bind(this));

    this.setState({
      submitting: true
    });
  }

  cancel() {
    mc.ui.modal(null);
  }

  deleteActivity() {
    let activity = this.state.activity;

    mc.ui.alert(tx("delete_activity"), {
      level: "warn",
      mode: "confirm",
      labels: {
        confirm: tx("delete"),
        cancel: tx("cancel")
      },
      onHide: (function (confirmed) {
        if (confirmed) {
          actions.saveActivity(activity, "DELETE").then((function (payload) {
            if (payload.errors.length) {
              this.setState({
                errors: payload.errors,
                submitting: false
              });
            }
            else {
              mc.ui.modal(null);
              rc.actions.loadStudy(activity.studyId);
            }
          }).bind(this));
        }

        this.setState({
          submitting: true
        });
      }).bind(this)
    });
  }

  isValid() {
    let activity = this.state.activity;

    return (
      activity.displayName.trim().length > 0 &&
      activity.instructions.trim().length > 0 &&
      activity.questions.every(function (question) {
        if (!question.text.trim().length) {
          return false;
        }

        if (question.type === "MULTIPLECHOICE") {
          if (question.values.length < 2 || question.values.some((v) => v.trim().length === 0)) {
            return false;
          }
        }

        return true;
      })
    );
  }

  static open(activity, disabled) {
    let form = <ActivityFormView activity={activity} disabled={disabled}/>;

    mc.ui.modal(form, { width: "80%", height: "90%", dismissable: disabled });
  }

  render() {
    let activity = this.state.activity;
    let disabled = this.props.disabled;

    if (!activity) {
      return null;
    }

    let { hours, minutes, seconds } = mc.math.duration(activity.durationSec * 1000);

    return (
      <div className="rc-activity-form-view">
        <h1>{activity.id ? (activity.displayName || "...") : tx("new_activity")}</h1>
        <div>
          <section>
            <h2>{tx("activity_name")}</h2>
            <input name="displayName" type="text" size="40" maxLength="64" value={activity.displayName} onChange={this.setDisplayName.bind(this)} disabled={disabled}/>
          </section>
          <section>
            <h2>{tx("duration")}</h2>
            <label>
              <input name="durationMode" value="untimed" type="radio" checked={activity.durationSec === 0} onChange={this.setUntimed.bind(this)} disabled={disabled}/>
              {tx("untimed")}
            </label>
            <label>
              <input name="durationMode" value="timed" type="radio" checked={activity.durationSec !== 0} onChange={this.setTimed.bind(this)} disabled={disabled}/>
              {tx("timed")}
            </label>
            {activity.durationSec > 0 && (
              <div style={{ marginTop: "1em" }}>
                <FormRange name="hours" min={0} max={24} value={hours} onChange={this.setHours.bind(this)} disabled={disabled}/><span>{"h "}</span>
                <FormRange name="minutes" min={0} max={59} value={minutes} onChange={this.setMinutes.bind(this)} disabled={disabled}/><span>{"m "}</span>
                <FormRange name="seconds" min={0} max={59} value={seconds} onChange={this.setSeconds.bind(this)} disabled={disabled}/><span>{"s "}</span>
              </div>
            )}
          </section>
          <section>
            <h2>{tx("instructions")}</h2>
            <textarea name="instructions" value={activity.instructions} rows="5" cols="40" onChange={this.setInstructions.bind(this)} disabled={disabled}/>
          </section>
          <section>
            <h2>{tx("assessment")}</h2>
            <QuestionEditor questions={activity.questions} onEdit={this.setQuestions.bind(this)} disabled={disabled}/>
          </section>
          <FormFeedback errors={this.state.errors}/>
          <FormControls
            onSave={this.saveActivity.bind(this)}
            onCancel={this.cancel.bind(this)}
            onDelete={!disabled && activity.id && this.deleteActivity.bind(this)}
            enabled={!disabled && this.isValid() && !this.state.submitting}/>
        </div>
      </div>
    );
  }
}

module.exports = ActivityFormView;